//Should be changed to be conditionally imported
import VimeoPlayer from '@vimeo/player';

export default class Modal {
    constructor(elm) {
        if (!elm.dataset.modalId)
            return;

        var opener = document.querySelectorAll('[data-modal-opens=' + elm.dataset.modalId + ']');

        if (!opener)
            return;

        let iframe = elm.querySelector('iframe');
        let videoPlayer = elm.dataset.videoPlayer;
        let vimeoPlayer = null;

        if (elm.dataset.videoPlayer === 'vimeo') {
            if (iframe) {
                vimeoPlayer = new VimeoPlayer(iframe);
            }
        }

        opener.forEach(x => x.addEventListener('click', function () { toggleModal(elm); }));
        elm.addEventListener('click', function (e) {
            if (!e.target.closest("video, iframe")) {             
                toggleModal(elm);
            }

        });

        document.onkeydown = function (evt) {
            evt = evt || window.event;
            if (evt.keyCode == 27) {
                toggleModal(elm);
            }
        };

        var toggleModal = function (modal) {
            const iframeContainer = modal.querySelector('.responsive-container');
            const videoEmbedMarkup = urlSafeBase64Decode(modal.dataset.encodedEmbed);

            if (modal.classList.contains('modal--active')) {
                //Closing
                modal.classList.remove('modal--active');
                if (videoPlayer == "youtube") {
                    iframeContainer.innerHTML = "";
                } else {
                    //Stopping & resetting video if any
                    if (iframe) {
                        if (videoPlayer == "vimeo") {
                            if (vimeoPlayer) {
                                vimeoPlayer.setCurrentTime(0);
                                vimeoPlayer.pause();
                            }
                        } else if (videoPlayer == "youtube") {
                            if (iframe.src.indexOf('?autoplay=1') > -1) {
                                iframe.src = iframe.src.replace('?autoplay=1', '');
                            } else {
                                iframe.src = iframe.src.replace('&autoplay=1', '');
                            }
                        }
                    } else {
                        //For potential mp4 player
                        var video = modal.querySelector('video');
                        video.pause();
                        video.currentTime = 0;
                    }
                }                
            } else {
                //Opening
                modal.classList.add('modal--active');
                //Playing video if any               
                if (iframe) {
                    if (videoPlayer == "vimeo") {
                        if (vimeoPlayer) {
                            vimeoPlayer.setCurrentTime(0);
                            vimeoPlayer.play();
                        }
                    }
                } else {
                    if (videoPlayer == "youtube") {
                        iframeContainer.innerHTML = videoEmbedMarkup;
                    }
                    else {
                        //For potential mp4 player
                        var video = modal.querySelector('video');
                        video.play();
                    }                    
                }
            }
        }

        // should be moved out to its own utility component
        var urlSafeBase64Decode = function(encodedString) {
            // Replace any characters that are URL-safe encoded back to their original form
            encodedString = encodedString.replace(/-/g, '+').replace(/_/g, '/');
            // Use atob() to decode the base64 string
            let decodedString = atob(encodedString);
            return decodedString;
        }
    }
}
